import GlobalStylesComponent from './GlobalStyles.component';

export default function GlobalStylesContainer() {
  return (
    <GlobalStylesComponent />
  );
}
